module.exports = __webpack_public_path__ + "static/media/Creativity.a52730de.webp";